import { createFileRoute } from '@tanstack/react-router';
import { requireRole } from '@/lib/routeGuards';
import { MessagingProfilesList } from '@/components/admin/messaging';

// Subsidiary-wide registration list, platform-admin only like the profile page it links to.
export const Route = createFileRoute('/admin/messaging/profiles')({
  beforeLoad: ({ context }) => {
    requireRole(context, ['admin'], '/admin/messaging/profiles');
  },
  component: MessagingProfilesList,
});
